// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip[data-v-4560d3c2] {\n  position: relative;\n  display: inline-block;\n}\n.tooltip .tooltiptext[data-v-4560d3c2] {\n  position: absolute;\n  visibility: hidden;\n  z-index: 10;\n  text-align: center;\n  font-size: 0.875rem;\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  border-radius: 0.375rem;\n  bottom: 120%;\n  right: 0;\n}\n.tooltip:hover .tooltiptext[data-v-4560d3c2] {\n  visibility: visible;\n}\n", ""]);
// Exports
module.exports = exports;
